import { render, staticRenderFns } from "./OldVersion.vue?vue&type=template&id=999e4276"
import script from "./OldVersion.vue?vue&type=script&lang=js"
export * from "./OldVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports